import About from './Components/About';
import {
    Divider,
    Container,
    Typography,
    Box,
    useTheme,
    useMediaQuery,
    Fade
} from '@mui/material';
// Icons for hidden sections (commented out)
// import {
//     Lightbulb,
//     EmojiEvents,
//     Handshake,
//     VerifiedUser,
//     Engineering,
//     Speed,
//     CheckCircle,
//     Psychology
// } from '@mui/icons-material';

export default function AboutScreen() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    // CSS Variables from App.css
    // eslint-disable-next-line no-unused-vars
    const PRIMARY_COLOR = '#6C98AD';
    // eslint-disable-next-line no-unused-vars
    const SECONDARY_COLOR = '#24272a';

    // Hidden sections - coreValues, serviceAreas, whyChooseUs are temporarily disabled

    return (
        <Box sx={{ width: '100%', overflowX: 'hidden' }}>
            {/* Hero Section with Gradient Background */}
            <Box
                sx={{
                    color: '#2B2F32',
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    py: { xs: 8, md: 12 },
                    mb: 0,
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'0.05\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
                        opacity: 0.1
                    }
                }}
            >
                <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
                    <Fade in timeout={800}>
                        <Box sx={{ textAlign: 'center' }}>
                            <Typography
                                variant={isMobile ? 'h3' : 'h2'}
                                component="h1"
                                gutterBottom
                                sx={{
                                    fontWeight: 700,
                                    mb: 2,
                                }}
                            >
                                Who We Are
                            </Typography>
                            <Typography
                                variant={isMobile ? 'h6' : 'h5'}
                                sx={{
                                    maxWidth: '800px',
                                    mx: 'auto',
                                    opacity: 0.95,
                                    fontWeight: 300
                                }}
                            >
                                Tailored Alloys develops software and hardware to unlock the potential of laser-powder bed fusion
                                for all its many applications: hypersonic vehicles applications, refractory alloys, first time right
                                and point of need, and more. Ring sales fund this research while providing our customers with jewelry
                                worthy of pride.
                            </Typography>
                        </Box>
                    </Fade>
                </Container>
            </Box>

            {/* Section Divider */}
            <div className='section-divider'>
                <Divider sx={{
                    borderBottomWidth: '4px',
                    margin: '30px',
                    width: '60px',
                    borderColor: PRIMARY_COLOR,
                    borderRadius: '2px',
                    opacity: 0.8
                }} />
            </div>

            {/* Team Section */}
            <Container maxWidth="lg" sx={{ mb: 8 }}>
                <Box
                    sx={{
                        textAlign: 'center',
                        mb: 4,
                        position: 'relative',
                        '&::after': {
                            content: '""',
                            display: 'block',
                            width: '60px',
                            height: '4px',
                            background: PRIMARY_COLOR,
                            margin: '20px auto 0',
                            borderRadius: '2px'
                        }
                    }}
                >
                    <Typography
                        variant="h3"
                        component="h2"
                        sx={{
                            color: SECONDARY_COLOR,
                            fontWeight: 700,
                            fontSize: { xs: '2rem', md: '3rem' }
                        }}
                    >
                        Meet Our Team
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            mt: 2,
                            fontSize: '1.1rem',
                            color: '#666',
                            maxWidth: '700px',
                            mx: 'auto'
                        }}
                    >
                        The brilliant minds behind Tailored Alloys' innovative solutions
                    </Typography>
                </Box>
                <About />
            </Container>

            {/* Section Divider */}
            <div className='section-divider'>
                <Divider sx={{
                    borderBottomWidth: '4px',
                    margin: '30px',
                    width: '60px',
                    borderColor: PRIMARY_COLOR,
                    borderRadius: '2px',
                    opacity: 0.8
                }} />
            </div>

            {/* Why Choose Us Section - Hidden */}
        </Box>
    );
}
